/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DeepAnalysisControllerAnswerMutationRequest, DeepAnalysisControllerAnswerMutationResponse, DeepAnalysisControllerAnswerPathParams, DeepAnalysisControllerAnswer400, DeepAnalysisControllerAnswer401, DeepAnalysisControllerAnswer403, DeepAnalysisControllerAnswer404 } from "../../models/aiAgentV2Controller/DeepAnalysisControllerAnswer";

function getDeepAnalysisControllerAnswerUrl(sessionId: DeepAnalysisControllerAnswerPathParams["sessionId"]) {
  const res = { method: 'PATCH', url: `/api/v1/ai-agent-v2/deep-analysis/${sessionId}/answers` as const }  
  return res
}

/**
 * @summary Submit deep analysis answers
 * {@link /api/v1/ai-agent-v2/deep-analysis/:sessionId/answers}
 */
export async function deepAnalysisControllerAnswer(sessionId: DeepAnalysisControllerAnswerPathParams["sessionId"], data?: DeepAnalysisControllerAnswerMutationRequest, config: Partial<RequestConfig<DeepAnalysisControllerAnswerMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DeepAnalysisControllerAnswerMutationResponse, ResponseErrorConfig<DeepAnalysisControllerAnswer400 | DeepAnalysisControllerAnswer401 | DeepAnalysisControllerAnswer403 | DeepAnalysisControllerAnswer404>, DeepAnalysisControllerAnswerMutationRequest>({ method : "PATCH", url : getDeepAnalysisControllerAnswerUrl(sessionId).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}